module.exports = __webpack_public_path__ + "images/emoji_1_color5ced445f9fc876ed606922d7c76326ed.svg";